import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="page-404" className="min-h-[70vh] flex items-center justify-center px-6 py-24">
      <div className="text-center">
        <div className="text-8xl md:text-9xl font-extrabold tracking-tighter text-[#1F1E4E]">4<span className="text-[#00A651]">0</span>4</div>
        <p className="mt-4 text-lg text-slate-600">This page clocked out. Let's get you back.</p>
        <Link to="/" data-testid="404-home-btn" className="inline-flex mt-6 bg-[#00A651] hover:bg-[#008A43] text-white font-bold rounded-lg px-6 py-3">Back to Home</Link>
      </div>
    </div>
  );
}
